var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFormatPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83317 22.6667C8.1915 22.6667 7.64239 22.4384 7.18584 21.9818C6.7285 21.5245 6.49984 20.975 6.49984 20.3333V15.6667H2.99984C2.35817 15.6667 1.80906 15.438 1.3525 14.9807C0.89517 14.5241 0.666504 13.975 0.666504 13.3333V5.16667C0.666504 3.88333 1.12345 2.78472 2.03734 1.87083C2.95123 0.956945 4.04984 0.5 5.33317 0.5H19.3332V13.3333C19.3332 13.975 19.1049 14.5241 18.6483 14.9807C18.191 15.438 17.6415 15.6667 16.9998 15.6667H13.4998V20.3333C13.4998 20.975 13.2716 21.5245 12.815 21.9818C12.3577 22.4384 11.8082 22.6667 11.1665 22.6667H8.83317ZM2.99984 8.66667H16.9998V2.83333H15.8332V7.5H13.4998V2.83333H12.3332V5.16667H9.99984V2.83333H5.33317C4.6915 2.83333 4.14239 3.062 3.68584 3.51933C3.2285 3.97589 2.99984 4.525 2.99984 5.16667V8.66667ZM2.99984 13.3333H16.9998V11H2.99984V13.3333Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormatPaint);
export default __webpack_public_path__ + "static/media/icon_format_paint.83cc880e8697c624323a37355513958a.svg";
export { ForwardRef as ReactComponent };